import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeMusicToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeMusicToYoutube}
            sections={<PairTransferGuideContent sourceKey="youtubeMusic" destKey="youtube" />}
        />
    );
}
